import { ReadonlyRepositoryListService } from '@softline/core';
import { SupplierPrice } from '@softapps/wws/core';
import { computed, inject, signal } from '@angular/core';
import { SupplierPriceRepository } from '../repositories/supplier-price.repository';
import { SupplierPriceQuery } from '../types/supplier-price.query';

export class SupplierPriceService extends ReadonlyRepositoryListService<
  SupplierPrice,
  SupplierPrice[],
  SupplierPriceQuery
> {
  readonly repo = inject(SupplierPriceRepository);
  productId = signal<number>(0);
  supplierId = signal<number>(0);
  allPrices = signal<boolean>(false);

  override params = computed(() => ({
    productId: this.productId() ?? undefined,
    supplierId: this.supplierId(),
    all: this.allPrices(),
  }));

  constructor() {
    super(inject(SupplierPriceRepository));
  }

  protected override getItems(
    result: SupplierPrice[] | null | undefined
  ): SupplierPrice[] {
    return result as SupplierPrice[];
  }

  async getPricesOfSupplier(supplierId: number | string): Promise<SupplierPrice[]> {
    const productId = this.productId();
    if(!productId) return Promise.resolve([]);

    return await this.repo.getPricesOfSupplier(productId, supplierId);
  }
}
